import { apiClient } from 'container/apiClient';
import { DemographyApi } from 'api/DemographyApi';

export const demographyApi = new DemographyApi(apiClient);
